import { useEffect, useState } from "react";
import { toast } from "sonner";
import ImageUpload from "@/components/admin/ImageUpload";
import { api } from "@/lib/api";
import { invalidateSiteContent } from "@/lib/content";

const FIELDS = [
  { key: "hero_image", label: "Hero home — immagine principale" },
  { key: "reel_poster", label: "Showreel — copertina" },
  { key: "reel_video", label: "Showreel — video (link YouTube/Vimeo o file MP4)" },
  { key: "area_product", label: "Card area — Product" },
  { key: "area_architecture", label: "Card area — Architecture" },
  { key: "area_food", label: "Card area — Food" },
  { key: "area_motion", label: "Card area — Motion / AI / Video" },
  { key: "ai_image", label: "Sezione AI — immagine" },
  { key: "about_portrait", label: "Pagina About — ritratto" },
];

const SiteImages = () => {
  const [content, setContent] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get("/content").then((res) => setContent(res.data)).catch(() => toast.error("Errore nel caricamento"));
  }, []);

  const setKey = (key) => (value) => setContent((prev) => ({ ...prev, [key]: value }));
  const setFrame = (index) => (value) =>
    setContent((prev) => ({ ...prev, reel_frames: (prev.reel_frames || []).map((f, i) => (i === index ? value : f)) }));

  const handleSave = async () => {
    setSaving(true);
    try {
      await api.put("/admin/content", content);
      invalidateSiteContent();
      toast.success("Immagini del sito aggiornate");
    } catch {
      toast.error("Salvataggio non riuscito");
    } finally {
      setSaving(false);
    }
  };

  if (!content) return <p className="text-xs font-mono tracking-[0.25em] text-fog">CARICAMENTO…</p>;

  return (
    <div data-testid="admin-site-images-page">
      <h1 className="text-2xl font-normal tracking-tight text-bone">Immagini del sito</h1>
      <p className="mt-1 text-sm text-fog">Sostituisci le immagini delle sezioni della home e della pagina About. Carica un file dal tuo Mac o incolla un URL.</p>

      <div className="mt-8 grid md:grid-cols-2 gap-5">
        {FIELDS.map((field) => (
          <ImageUpload
            key={field.key}
            label={field.label}
            value={content[field.key] || ""}
            onChange={setKey(field.key)}
            testId={`content-${field.key}`}
          />
        ))}
      </div>

      <p className="mt-10 text-[10px] font-mono tracking-[0.25em] text-fog uppercase">Showreel — i 5 frame della striscia in home</p>
      <div className="mt-4 grid md:grid-cols-2 gap-5">
        {(content.reel_frames || []).map((frame, i) => (
          <ImageUpload
            key={i}
            label={`Frame ${i + 1}`}
            value={frame}
            onChange={setFrame(i)}
            testId={`content-frame-${i}`}
          />
        ))}
      </div>

      <button
        onClick={handleSave}
        data-testid="content-save-button"
        disabled={saving}
        className="mt-10 px-10 py-4 bg-gold text-night text-xs font-semibold tracking-[0.2em] hover:bg-bone disabled:opacity-60 transition-colors duration-300"
      >
        {saving ? "SALVATAGGIO…" : "SALVA MODIFICHE"}
      </button>
    </div>
  );
};

export default SiteImages;
